// Centralised test ids for Playwright/E2E
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const HEADER = {
  wrapper: "site-header",
  logo: "header-logo",
  navStory: "nav-link-story",
  navProducts: "nav-link-products",
  navOrigin: "nav-link-origin",
  navJourney: "nav-link-journey",
  navContact: "nav-link-contact",
  shopBtn: "header-shop-soon-btn",
  mobileMenuBtn: "header-mobile-menu-btn",
};

export const HERO = {
  wrapper: "hero-section",
  headline: "hero-headline",
  subheadline: "hero-subheadline",
  ctaPrimary: "hero-cta-discover",
  ctaSecondary: "hero-cta-join",
  badgeOrigin: "hero-badge-origin",
  badgeQuality: "hero-badge-quality",
  badgeBatch: "hero-badge-small-batch",
};

export const STORY = {
  wrapper: "story-section",
  card: (i) => `story-card-${i}`,
};

export const PRODUCTS = {
  wrapper: "products-section",
  launchCard: "product-launch-card",
  launchCta: "product-launch-cta",
  futureCard: (i) => `product-future-card-${i}`,
};

export const ORIGIN = {
  wrapper: "origin-section",
  tagImo: "origin-tag-imo",
  tagAbia: "origin-tag-abia",
};

export const FARMTOTABLE = {
  wrapper: "farm-to-table-section",
  step: (i) => `farm-step-${i}`,
};

export const LIFESTYLE = {
  wrapper: "lifestyle-section",
  card: (i) => `lifestyle-card-${i}`,
};

export const SIGNUP = {
  wrapper: "signup-section",
  form: "signup-form",
  name: "signup-name-input",
  email: "signup-email-input",
  submit: "signup-submit-button",
  success: "signup-success-msg",
  error: "signup-error-msg",
  benefit: (i) => `signup-benefit-${i}`,
};

export const CONTACT = {
  wrapper: "contact-section",
  founder: "contact-founder",
  location: "contact-location",
  channel: (i) => `contact-channel-${i}`,
};

export const FOOTER = {
  wrapper: "site-footer",
  instagram: "footer-instagram",
  tiktok: "footer-tiktok",
  linkedin: "footer-linkedin",
  emailGeneral: "footer-email-general",
  legalImprint: "footer-legal-imprint",
  legalPrivacy: "footer-legal-privacy",
  legalTerms: "footer-legal-terms",
};

export const LEGAL = {
  wrapper: "legal-page",
  back: "legal-back-link",
};
